var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 316,
    viewBox: "0 0 1440 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C583.699 170.429 896.722 219.139 1440 47V316H0V0Z",
    fill: "url(#paint0_linear_680_441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C542.586 198.789 858.018 318.339 1440 119.5V316H0V0Z",
    fill: "url(#paint1_linear_680_441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_680_441",
    x1: 494.5,
    y1: 132.5,
    x2: 322.5,
    y2: 586.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24649F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_680_441",
    x1: 494.5,
    y1: 132.5,
    x2: 322.5,
    y2: 586.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4499E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3273AF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg1);
export default __webpack_public_path__ + "static/media/header-bg-1.94ac43a5a501cbc8cb731c388d45179f.svg";
export { ForwardRef as ReactComponent };